import { render, staticRenderFns } from "./detail-apport-modal.vue?vue&type=template&id=49ca9cd2&scoped=true"
import script from "./detail-apport-modal.vue?vue&type=script&lang=js"
export * from "./detail-apport-modal.vue?vue&type=script&lang=js"
import style0 from "./detail-apport-modal.vue?vue&type=style&index=0&id=49ca9cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ca9cd2",
  null
  
)

export default component.exports